import { render, staticRenderFns } from "./Property-Dropdown.vue?vue&type=template&id=254a5ba9"
import script from "./Property-Dropdown.vue?vue&type=script&lang=js"
export * from "./Property-Dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports